var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":"secondary","title":_vm.showToolTip ? 'Экспорт в Excel' : ''},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fa fa-file-excel-o"})])
}
var staticRenderFns = []

export { render, staticRenderFns }